import { useCallback, useEffect, useState } from "react";

export function useScrollToBottom(containerRef: React.RefObject<HTMLElement | null>) {
	const [showButton, setShowButton] = useState(false);
	const threshold = 100;

	const checkScroll = useCallback(() => {
		const el = containerRef.current;
		if (!el) return;
		const distance = el.scrollHeight - el.scrollTop - el.clientHeight;
		setShowButton(distance > threshold);
	}, [containerRef]);

	const scrollToBottom = useCallback(
		(behavior: ScrollBehavior = "smooth") => {
			const el = containerRef.current;
			if (!el) return;
			el.scrollTo({ top: el.scrollHeight, behavior });
			setShowButton(false);
		},
		[containerRef]
	);

	useEffect(() => {
		const el = containerRef.current;
		if (!el) return;
		el.addEventListener("scroll", checkScroll, { passive: true });
		return () => el.removeEventListener("scroll", checkScroll);
	}, [checkScroll, containerRef]);

	return { showButton, scrollToBottom };
}
